import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuetify from 'vuetify/lib/framework'
import { vuetifyConfig, customizeThemes } from './plugins/vuetify'
import { appConfig, loadCustomAppConfig } from './app-config.js'

Vue.config.productionTip = false

import '@/prototypes/Set'
import '@/plugins/browser'
import "@/plugins/vuetify-number.js"

// Para terminar o tamanho da tela use:
//    $vuetify.breakpoint.mdOnly

// Função assíncrona autoinvocável
(async function initializeApp() {

  // Aguarda a configuração ser carregada
  await loadCustomAppConfig();

  Vue.prototype.$app = appConfig

  // Aplicando tema customizado
  customizeThemes(appConfig.themes)

  const vuetifyInstance = new Vuetify(vuetifyConfig);

  new Vue({
    router,
    store,
    vuetify: vuetifyInstance,
    render: h => h(App)
  }).$mount('#app')

})();